import React from "react";
import PropTypes from "prop-types";
import "./bullseyeBranding.scss";

/** Component to show a custom branding text
 */

const BullseyeBranding = ({brandingImageURL, brandingTextURL, brandingText }) => {
  return (
    <span className="branding-wrap float-right">
      <img
        src={brandingImageURL}
        alt={brandingText}
        className="mr-1 my-1"
        style={{ maxHeight: 35 }}
      ></img>
      <a href={brandingTextURL}>{brandingText}</a>
    </span>
  );
};

BullseyeBranding.propTypes = {
  /** Receive the image path url to show */
  brandingImageURL: PropTypes.string,
  /** Receive the url related with the branding text */
  brandingTextURL: PropTypes.string,
  /** Receive the branding text */
  brandingText: PropTypes.string,
};

export default BullseyeBranding;
